<template>
    <div v-if="attachments.length" class="msg-attachments" data-cy="message-attachments">
        <!-- Pictures we can paint, as a grid that opens a carousel. -->
        <div v-if="images.length"
             class="msg-media-grid"
             :class="images.length === 1 ? 'msg-media-grid--single' : 'msg-media-grid--multi'">
            <button v-for="(image, i) in visibleImages"
                    :key="image.id"
                    type="button"
                    class="msg-media"
                    data-cy="message-media"
                    :aria-label="`Open ${image.name}`"
                    @click="openLightbox(i)">
                <img class="msg-media__img"
                     :src="srcFor(image)"
                     :alt="image.name"
                     loading="lazy"
                     @error="onImageError(image)" />
                <span v-if="hiddenCount && i === visibleImages.length - 1"
                      class="msg-media__more"
                      aria-hidden="true">+{{ hiddenCount }}</span>
            </button>
        </div>

        <!-- Everything else: documents, and any picture that would not decode. -->
        <attachment v-for="file in files" :key="file.id" :attachment="file"></attachment>

        <attachment-lightbox v-if="lightboxIndex !== null"
                             :images="images"
                             :start-index="lightboxIndex"
                             @close="lightboxIndex = null"></attachment-lightbox>
    </div>
</template>

<script>
import Attachment from './attachment.vue';
import AttachmentLightbox from './attachment_lightbox.vue';
import { isInlineImage } from '../utilities/attachment_types';

// Past this many, the grid shows a +N overlay on the last tile rather than
// growing the bubble without bound. The carousel still holds every image.
const MAX_VISIBLE = 4;

export default {
  name: 'message-attachments',
  components: { Attachment, AttachmentLightbox },
  props: {
    attachments: { type: Array, default: () => [] },
  },
  data() {
    return {
      // Images whose <img> refused to decode (wrong extension, dead URL, a
      // format this browser lacks). They demote to a file card, which still
      // opens in a new tab — a working link beats a broken tile.
      failedIds: [],
      lightboxIndex: null,
    };
  },
  computed: {
    images() {
      return this.attachments.filter(
        (a) => isInlineImage(a) && a.url && !this.failedIds.includes(a.id),
      );
    },
    files() {
      return this.attachments.filter((a) => !this.images.includes(a));
    },
    visibleImages() {
      return this.images.slice(0, MAX_VISIBLE);
    },
    hiddenCount() {
      return Math.max(0, this.images.length - MAX_VISIBLE);
    },
  },
  methods: {
    srcFor(image) {
      return decodeURI(image.url);
    },
    onImageError(image) {
      if (!this.failedIds.includes(image.id)) this.failedIds.push(image.id);
    },
    openLightbox(index) {
      this.lightboxIndex = index;
    },
  },
};
</script>
